import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";

export function useUsers() {
  const { data } = useQuery({
    queryKey: ["users"],
    queryFn: async () => (await api.get("/auth/users")).data,
    staleTime: 300_000,
  });
  const map = {};
  (data || []).forEach((u) => (map[u.id] = u));
  return { users: data || [], map };
}

export function useCompanies() {
  const { data } = useQuery({
    queryKey: ["companies"],
    queryFn: async () => (await api.get("/companies")).data,
    staleTime: 300_000,
  });
  const map = {};
  (data || []).forEach((c) => (map[c.id] = c));
  return { companies: data || [], map };
}

export function useTemplates() {
  const { data } = useQuery({
    queryKey: ["templates"],
    queryFn: async () => (await api.get("/process-templates")).data,
    staleTime: 300_000,
  });
  return data || [];
}

export function userName(map, id) {
  if (!id) return "—";
  if (id === "sistema") return "Sistema";
  return map[id]?.name || id;
}

export function userInitials(name) {
  return (name || "?").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}
